module.exports = __webpack_public_path__ + "img/cat4x3.e6d10d08.jpg";